import { VueConstructor } from 'vue';
import { CoreOptions } from '../../../../index';
import NoopAuthStrategy from './noopAuthStrategy';

export default {
  install: (Vue: VueConstructor, options: CoreOptions) => {
    const auth = new NoopAuthStrategy();
    Vue.$auth = auth;
    Vue.prototype.$auth = Vue.$auth;
  },
};
